import { Component,OnInit,OnDestroy,AfterViewInit,ViewChild } from "@angular/core";
import { NgbModal,NgbDropdown,NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiCompanyService
} from "src/app/shared/service";
import {
    PagingInfo
} from "src/app/shared/vo";

@Component({
    selector: "company-selector"
    ,templateUrl: "./company.selector.component.html"
    ,providers: [NgbDropdownConfig]
})
export class CompanySelectorComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;// 선택된 회사
    treeRootCompanyInfo:any;// 팝업에 보여줄 회사
    searchValue:string;
    listCompanyInfo:any[] = [];
    isOpenModalSearchCompany:boolean = false;
    @ViewChild("modalSearchCompany", { static: true }) modalSearchCompany: NgbDropdown;
    loginUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private ngbDropdownConfig:NgbDropdownConfig
    ) {
        this.ngbDropdownConfig.autoClose = false;
        this.loginUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.pagingInfo.pageSize = 65535;
    } 

    ngOnInit() {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        let userCompanyId = this.loginUserInfo.companyId;

        if(this.companyInfo === null){
            // 세션에 저장 된 회사정보가 없는 경우
            // 로그인 사용자의 회사를 기본선택
            this.getOneCompanyInfoForInit(userCompanyId);
        }

        this.reloadListItem();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.modalSearchCompany.close();
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    reloadListItem(){
        let searchInfo = {
            companyId:this.loginUserInfo.companyId
        };
        this.fvmsApiCompanyService.getListCompanyTreeRecursive(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.listCompanyInfo = response.resultValue;
                    this.convListTree(this.listCompanyInfo).then((listItems) => {
                        this.listCompanyInfo = listItems;
                        // console.log("reloadListItem",this.listCompanyInfo);
                    });
                }
            });
    }

    getOneCompanyInfo(userCompanyId:number){
        this.fvmsApiCompanyService.getOneCompanyTree(userCompanyId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.companyInfo = response.resultValue;
                    this.fvmsCommonService.setCompanyInfo(this.companyInfo);
                }
            });
    }

    getOneCompanyInfoForInit(userCompanyId:number){
        this.fvmsApiCompanyService.getOneCompanyTree(userCompanyId)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    this.companyInfo = response.resultValue;
                }
            });
    }

    clickOpenDropdown(){
        this.isOpenModalSearchCompany = this.modalSearchCompany.isOpen();
        if(this.isOpenModalSearchCompany === true){
            // this.searchValue = this.companyInfo?.companyNm || null;
            // this.reloadListItem();
            this.modalSearchCompany.open();
        }else{
            this.modalSearchCompany.close();
        }
    }

    clickSearchCompany(event:any){
        event.stopPropagation();
        // this.reloadListItem();
        this.fvmsCommonService.setSearchKeyword(this.searchValue);
    }

    clickSelectCompany(event:any,companyInfo:any){
        this.companyInfo = companyInfo;
        this.fvmsCommonService.setCompanyInfo(companyInfo);
        this.modalSearchCompany.close();
    }

    keyupEnterSearchValue(event:any){
        this.fvmsCommonService.setSearchKeyword(this.searchValue);
    }

    convListTree(listCompany:any[]):Promise<any[]>{
        let promise = new Promise<any[]>((resolve) => {
            let listItems = [];
            if(listCompany){
                let idxFoundRoot = listCompany.findIndex((item) => item.companyId === this.loginUserInfo.companyId);
                if(idxFoundRoot > -1){
                    let itemRoot = listCompany.splice(idxFoundRoot,1)[0];
                    itemRoot["isOpen"] = true;
                    itemRoot["children"] = [];
                    listItems.push(itemRoot);

                    let sizeListCompany = listCompany.length;
                    for(let a=0;a<sizeListCompany;a++){
                        let searchItem = listCompany[a];
                        if(searchItem.companyId === this.loginUserInfo.companyId){
                            continue;
                        }
                        searchItem["isOpen"] = false;
                        searchItem["children"] = [];
                        this.findTreeParent(searchItem,listItems);
                    }
                }
            }
            resolve(listItems);
        });
        return promise;
    }

    findTreeParent(itemSearch:any,listTree:any[]){
        if(listTree){
            var foundParent = listTree.find((item) => item.companyId === itemSearch.pCompanyId);
            if(foundParent){
                foundParent.children.push(itemSearch);
            }else{
                listTree.map((item) => {
                    this.findTreeParent(itemSearch,item.children);
                });
            }
        }
    }
}
